<template>
  <v-card
    v-if="teams.length"
    color="white"
    width="100%"
    rounded="lg"
    :disabled="cancelled"
  >
    <v-item-group
      v-model="slotSelected"
      :mandatory="!canSelectTeam && !disabled"
    >
      <v-container>
        <v-card-text
          v-for="(team, indexTeams) in teams"
          :key="`team-${indexTeams}`"
          :class="{'pt-4': indexTeams === 0}"
        >
          <!-- <v-card-text>
            <p>!disabled : {{ !disabled }} </p>
            <p>canSelectTeam : {{ canSelectTeam }} </p>
            <p>team.id === 'B' : {{ team.id === 'B' }} </p>
            <p>routeTeam : {{ routeTeam }} </p>
          </v-card-text> -->

          <v-row class="px-0 py-1">
            <v-col
              cols="12"
              class="pa-1 pl-3 d-flex justify-space-between align-center"
            >
              <v-item-group
                v-model="slotTeam"
              >
                <!-- !disabled && canSelectTeam && team.id === 'B' -->
                <div
                  :class="{ 'cursor-pointer': !disabled && canSelectTeam && team.id === 'B' && ['B', 'UNDEFINED'].includes(routeTeam) }"
                  @click="() => {
                    canSelectTeam && team.id === 'B' && ['B', 'UNDEFINED'].includes(routeTeam) ? (slotTeam = 0, slotSelected = -1) : null
                  }"
                >
                  <v-avatar
                    v-if="isChallenge"
                    color="white"
                    class="mr-2"
                    size="50"
                    rounded
                    :style="resolveSlotTeamStyle(slotTeam !== -1, team.id, canSelectTeam)"
                  >
                    <v-icon
                      v-if="canSelectTeam && team.id === 'B'"
                      :color="slotTeam !== -1 ? '#14AE5C' : '#3f3f3f'"
                      class="ma-0"
                      size="25"
                    >
                      {{ slotTeam !== -1 ? icons.mdiCheck : icons.mdiPlus }}
                    </v-icon>
                    <v-img
                      v-else
                      :src="team.logo ? team.logo : icons.teamShield"
                    />
                  </v-avatar>
                  <span class="font-weight-bold black--text">{{
                    canSelectTeam && team.id === 'B' ? (slotTeam === -1 ? $t('game.rival_team') : $t('game.selected_team')) :
                    team.name
                  }}</span>
                </div>
              </v-item-group>

              <v-btn
                v-if="showEdit && myTeam === team.id"
                class="pa-0 text-end no-bg-hover mr-1 text-body-1 font-weight-bold black--text"
                rounded
                text
                style="
                  text-transform: inherit;
                  min-width: 70px;
                "
                :ripple="false"
                @click="$emit('edit-players')"
              >
                {{ t('tooltip.edit') }}
              </v-btn>
            </v-col>
          </v-row>

          <v-row
            v-for="(player, index) in team.players"
            :id="`player-${player.slot}`"
            :key="`player-${player.slot}`"
            class="pa-0 pt-3 ma-0"
            :class="{ 'b-bottom': index !== team.length - 1, 'pt-4': index === 0 }"
          >
            <!-- <v-col>
              <p>canSelectTeam && team.id === 'B' : {{ canSelectTeam && team.id === 'B' }}</p>
              <p>player.empty && player.selectable && !isJoined && !disabled : {{ player.empty && player.selectable && !isJoined && !disabled }}</p>
              <p>isJoined && team.my_team && (player.empty || player.additional) : {{ isJoined && team.my_team && (player.empty || player.additional) }}</p>
              <p></p>
              <p></p>
            </v-col> -->

            <v-item
              v-slot="{ active, toggle }"
              :value="player.slot"
              :class="{'cursor-pointer': (((canSelectTeam && team.id !== 'B') || !canSelectTeam) && (player.empty && player.selectable && !disabled)) || (isJoined && (team.my_team || !isChallenge) && (player.empty || player.additional))}"
            >
              <v-col
                cols="12"
                class="pa-0 d-flex justify-space-between align-center"
                @click="() => {
                  canSelectTeam && team.id === 'B' ? null :
                  player.empty && player.selectable && !isJoined && !disabled ? (toggle(), slotTeam = -1) :
                  isJoined && (team.my_team || !isChallenge) && (player.empty || player.additional) ? $emit('share') :
                  (null, !canSelectTeam ? slotTeam = -1 : null)
                }"
              >
                <div
                  class="d-flex align-center justify-space-between"
                  :style="`opacity: ${ isChallenge ? '1' : canSelectTeam && team.id === 'B' ? '0.7' : !player.empty || player.selectable || ((isChallenge && player.empty && team.my_team) || (!isChallenge && player.empty) || (canSelectTeam && team.id === 'A')) ? '1' : '0.7'};`"
                >
                  <v-badge
                    v-if="player.pr !== null || player.nprd !== null"
                    class="nprd-badge"
                    avatar
                    bottom
                    offset-x="12"
                    offset-y="12"
                    :color="resolveBadgeColor(player)"
                    :content="player.nprd !== null ? (player.nprd > 0 ? `+${player.nprd}` : `${player.nprd}`) : `${player.pr}`"
                  >
                    <v-avatar
                      color="white"
                      :class="{ 'v-avatar-light-bg primary--text': !player.empty }"
                      :style="resolvePlayerStyle(player, active, team.id)"
                      size="35"
                    >
                      <v-img
                        v-if="player.avatar"
                        :src="player.avatar"
                      ></v-img>
                      <span
                        v-else-if="player.fullname"
                        class="font-weight-medium"
                      >{{ avatarText(player.fullname) }}</span>
                      <v-icon
                        v-else
                        :color="active ? '#14AE5C' : '#3f3f3f'"
                        class="ma-0"
                        size="25"
                      >
                        {{
                          active ? icons.mdiCheck :
                          canSelectTeam && team.id === 'B' ? null :
                          player.selectable || (player.empty && team.my_team) ? icons.mdiPlus :
                          null
                        }}
                      </v-icon>
                    </v-avatar>
                  </v-badge>

                  <v-avatar
                    v-else
                    color="white"
                    :class="{ 'v-avatar-light-bg primary--text': !player.empty }"
                    :style="resolvePlayerStyle(player, active, team.id)"
                    size="35"
                  >
                    <v-img
                      v-if="player.avatar"
                      :src="player.avatar"
                    ></v-img>
                    <span
                      v-else-if="player.fullname"
                      class="font-weight-medium"
                    >{{ avatarText(player.fullname) }}</span>
                    <v-icon
                      v-else
                      :color="active ? '#14AE5C' : '#3f3f3f'"
                      class="ma-0"
                      size="25"
                    >
                      <!-- remove team -->
                      <!-- {{ active ? icons.mdiCheck : icons.mdiPlus }} -->
                      {{
                        active ? icons.mdiCheck :
                        canSelectTeam && team.id === 'B' ? null :
                        player.selectable || ((isChallenge && player.empty && team.my_team) || (!isChallenge && player.empty)) ? icons.mdiPlus :
                        null
                      }}
                    </v-icon>
                  </v-avatar>

                  <div class="d-flex flex-column ml-2 justify-center">
                    <span
                      :class="{ 'black--text': !player.empty, 'font-weight-bold': player.empty && active }"
                    >
                      {{ player.fullname ? player.fullname : player.additional ? $t('game.additional') : active ? $t('game.slot_selected') : $t('game.available') }}
                    </span>

                    <span
                      v-if="player.is_organizer === 'Y'"
                      class="text-xs"
                    >
                      {{ t('player_actions.organizer') }}
                    </span>
                  </div>
                </div>

                <div v-if="!player.empty && isJoined && (!isChallenge || (isChallenge && myTeam === team.id))">
                  <v-chip>
                    <img
                      v-if="player.paid === 'Y'"
                      :src="icons.moneyBill"
                      height="20px"
                      width="20px"
                      alt="moneyBill"
                      attrs="moneyBill"
                      style="background-position: center center; margin-right: 8px"
                    />
                    <span
                      class="text-sm"
                      :class="{ 'font-weight-bold': player.paid === 'Y' }"
                      :style="player.paid === 'N' ? { color: '#9b9b9b' } : {}"
                    >
                      {{ player.paid === 'Y' ? t('status.paid') : t('status.not_paid') }}
                    </span>
                  </v-chip>
                </div>

                <div v-if="showActions && false">
                  <player-action
                    v-if="false"
                    :show-remove="player.show_remove"
                    :show-leave="player.show_leave"
                    :show-add="player.show_add"
                    @add-guest="openCloseAddGuest(player.slot)"
                    @remove-player="onRemovePlayer(player.user_id, player.guest, player.slot)"
                    @leave-player="onLeave"
                  />

                  <v-chip v-if="player.showActions">
                    <v-icon
                      class="mr-2"
                      color="#FFBF00"
                    >
                      {{ icons.mdiSeal }}
                    </v-icon>
                    <span class="text-medium">
                      {{ player.seal }}
                    </span>
                  </v-chip>
                </div>
              </v-col>
            </v-item>
          </v-row>

          <v-divider
            v-if="indexTeams !== teams.length - 1"
            class="mt-7 mb-5"
            style="border-color: #9B9B9B"
          />
        </v-card-text>
      </v-container>
    </v-item-group>

    <v-container
      v-if="totalVotes !== null && totalVotes !== undefined && totalVotes > 0"
      class="pt-0"
    >
      <v-card-text
        cols="12"
        class="d-flex align-center"
      >
        <v-tooltip
          bottom
        >
          <template #activator="{ on: tooltip, attrs }">
            <v-icon
              size="20"
              color="info"
              class="mr-1"
              v-bind="attrs"
              v-on="{ ...tooltip }"
            >
              {{ icons.mdiInformationOutline }}
            </v-icon>
          </template>
          <span>{{ $t('game.total_votes_msg') }}</span>
        </v-tooltip>

        <label>
          {{ totalVotes }} {{ $t('game.total_votes') }}
        </label>
      </v-card-text>
    </v-container>
  </v-card>
</template>

<script>
import { ref, computed } from '@vue/composition-api'
import { useUtils } from '@core/libs/i18n'
import { avatarText } from '@core/utils/filter'
import {
  removePlayer, paidPlayer, editMatchInfo, leavePlayer, addGuest, removeGuest,
} from '@api'
import {
  mdiPlus,
  mdiSeal,
  mdiCheck,
  mdiSlashForward,
  mdiInformationOutline,
} from '@mdi/js'
import PlayerAction from '@/views/landing/components/player-action/PlayerAction.vue'

export default {
  name: 'PlayerList',
  components: {
    PlayerAction,
  },
  props: {
    teams: {
      type: Array,
      default: () => [],
      required: true,
    },
    playerQuantity: {
      type: Number,
      default: 0,
      required: true,
    },
    showActions: {
      type: Boolean,
      default: false,
    },
    showEdit: {
      type: Boolean,
      default: false,
    },
    isPrivate: {
      type: Boolean,
      default: false,
    },
    isOrganizer: {
      type: Boolean,
      default: false,
    },
    isPlayer: {
      type: Boolean,
      default: false,
    },
    isJoined: {
      type: Boolean,
      default: false,
      required: true,
    },
    selected: {
      type: [Number, String],
      default: 0,
      required: true,
    },
    teamSelected: {
      type: [Number, String],
      default: -1,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },

    // remove chanllenge
    isChallenge: {
      type: Boolean,
      default: false,
    },
    myTeam: {
      type: String,
      default: '',
    },
    totalVotes: {
      type: Number,
      default: 0,
    },
    canSelectTeam: {
      type: Boolean,
      default: false,
    },
    cancelled: {
      type: Boolean,
      default: false,
    },
    routeTeam: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const { t } = useUtils()

    const slotSelected = computed({
      get: () => props.selected,
      set: value => emit('update-selected', value),
    })

    const slotTeam = computed({
      get: () => props.teamSelected,
      set: value => emit('update-team-selected', value),
    })

    const isDialogChangePlayers = ref(false)
    const isDialogAddGuest = ref(false)
    const dataGuest = ref({
      guest_phone_number: null,
      guest_name: null,
    })

    const computedMatchCode = computed(() => JSON.parse(localStorage.getItem('matchCode')))
    const computedTitle = computed(() => props.title)

    const openClose = val => {
      isDialogChangePlayers.value = val
    }

    const resolvePlayerStyle = (player, active, teamId) => {
      if (player.its_me) return { border: '2px solid #14AE5C !important' }
      if (active && player.empty && !props.isJoined) return { border: '1.5px solid #14AE5C !important', backgroundColor: '#14ae5c40 !important' }
      if (!props.isChallenge && !player.selectable && player.empty && props.isJoined) return { border: '1.5px dashed #3f3f3f !important' }
      if (!player.selectable && player.empty && props.isJoined && props.myTeam === teamId) return { border: '1.5px dashed #3f3f3f !important' }
      if (!player.selectable || (props.canSelectTeam && teamId === 'B')) return { border: '1.5px solid #3f3f3f !important' }
      if (player.empty) return { border: '1.5px dashed #3f3f3f !important' }

      return {}
    }

    const resolveSlotTeamStyle = (active, teamId, canSelectTeam) => {
      if (active && teamId === 'B' && canSelectTeam) return { border: '1.5px solid #14AE5C !important', backgroundColor: '#14ae5c40 !important' }
      if (active && teamId === 'B' && canSelectTeam) return { border: '1.5px solid #14AE5C !important', backgroundColor: '#14ae5c40 !important' }
      if (!active && teamId === 'B' && canSelectTeam) return { border: '1.5px dashed #3f3f3f !important' }

      return { border: '1.5px solid #cecece !important' }
    }

    const resolveBadgeColor = player => {
      if (player.nprd !== null) {
        if (player.nprd === 0) return '#FFBD1B'
        if (player.nprd > 0) return '#14AE5C'
        if (player.nprd < 0) return '#FF3232'
      }

      if (player.pr !== null) return '#3F3F3F'

      return '#3F3F3F'
    }

    const onChangeQuantity = async val => {
      const resp = await editMatchInfo(computedMatchCode.value, { match_players_qty: val })
      if (resp.ok) {
        isDialogChangePlayers.value = false
        emit('refresh-match')
      }
    }

    const openCloseAddGuest = val => {
      isDialogAddGuest.value = true
      dataGuest.value.slot = val
    }

    const onAddGuest = async val => {
      dataGuest.value.guest_name = val.guest_name
      dataGuest.value.guest_phone_number = val.guest_phone_number
      dataGuest.value.match_code = computedMatchCode.value

      const resp = await addGuest(dataGuest.value)
      if (resp.ok) {
        isDialogAddGuest.value = false
        emit('refresh-match')
      }
    }

    const onLeave = async () => {
      const resp = await leavePlayer(computedMatchCode.value)
      if (resp.ok) emit('refresh-match')
    }

    const onRemovePlayer = async (user, guest, slot) => {
      let resp = null
      if (guest) resp = await removeGuest(computedMatchCode.value, slot)
      else resp = await removePlayer(computedMatchCode.value, user)

      if (resp.ok) emit('refresh-match')
    }

    const onPayPlayer = async (paid, slot, isOrganizer) => {
      if (isOrganizer) {
        const resp = await paidPlayer(computedMatchCode.value, {
          match_player_paid: paid,
          slot,
        })

        if (resp.ok) emit('refresh-match')
      }
    }

    return {
      // data
      isDialogChangePlayers,
      isDialogAddGuest,
      slotSelected,
      slotTeam,

      // computed
      computedTitle,

      // methods
      openClose,
      onChangeQuantity,
      openCloseAddGuest,
      onAddGuest,
      onRemovePlayer,
      onPayPlayer,
      onLeave,
      avatarText,
      resolvePlayerStyle,
      resolveSlotTeamStyle,
      resolveBadgeColor,

      // i18n
      t,

      icons: {
        mdiPlus,
        mdiSeal,
        mdiCheck,
        mdiSlashForward,
        mdiInformationOutline,
        moneyBill: require('@/assets/images/svg/money-bill.svg'),
      },
    }
  },
}
</script>

<style lang="scss">
.nprd-badge .v-badge__badge {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  font-weight: 800;
  min-width: 18px;
  height: 18px;
}
</style>
